(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalNeuerTarifController', ModalNeuerTarifController);

    ModalNeuerTarifController.$inject = [
        '$modalInstance',
        '$log',
        'lodash',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService'
    ];

    function ModalNeuerTarifController($modalInstance, $log, _, AppConfig, AngebotModel, BasisAngebotService) {
        var vm = this,
            AngebotSpezifischService,
            angebot;

        $log.debug('ModalNeuerTarifController', vm);

        vm.onOk = onOk;
        vm.onCancel = onCancel;
        vm.isBtnOkErlaubt = isBtnOkErlaubt;

        activate();

        function activate() {
            angebot = AngebotModel.get().angebot;
            AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (angular.isFunction(AngebotSpezifischService.getModalNeuerTarifContent)) {
                vm.content = AngebotSpezifischService.getModalNeuerTarifContent(angebot);
            } else {
                vm.content = AppConfig.MESSAGES.angebotNeuerTarif;
            }
        }
        function onOk() {
            $modalInstance.close();
        }
        function onCancel() {
            $modalInstance.dismiss('cancel');
        }
        function isBtnOkErlaubt() {
            return (
                _.get(AppConfig, 'MODAL.neuerTarif.buttonOk')
            );
        }
    }

})();
